import { createContext, useContext, useReducer } from "react";
import { getItemFromStore } from "shared/falcon/helpers/utils";
import useToggleStyle from "shared/falcon/hooks/useToggleStyle";
import { configReducer } from "shared/falcon/reducers/configReducer";
import { settings } from "../../../config";

const AppConfigContext = createContext({
  config: settings,
  setConfig: (string, value) => {},
  configDispatch: (action) => {},
});

export const AppContextProvider = ({ children }) => {
  const configState = {
    isFluid: getItemFromStore("isFluid", settings.isFluid),
    isRTL: getItemFromStore("isRTL", settings.isRTL),
    isDark: getItemFromStore("isDark", settings.isDark),
    navbarPosition: getItemFromStore("navbarPosition", settings.navbarPosition),
    isNavbarVerticalCollapsed: getItemFromStore(
      "isNavbarVerticalCollapsed",
      settings.isNavbarVerticalCollapsed
    ),
    navbarStyle: getItemFromStore("navbarStyle", settings.navbarStyle),
    currency: settings.currency,
    showBurgerMenu: settings.showBurgerMenu,
    showSettingPanel: false,
    navbarCollapsed: false,
  };

  const [config, configDispatch] = useReducer(configReducer, configState);

  const setConfig = (key, value) => {
    configDispatch({
      type: "SET_CONFIG",
      payload: {
        key,
        value,
        setInStore: [
          "isFluid",
          "isRTL",
          "isDark",
          "navbarPosition",
          "isNavbarVerticalCollapsed",
          "navbarStyle",
        ].includes(key),
      },
    });
  };

  const { isLoaded } = useToggleStyle(
    config.isRTL,
    config.isDark,
    configDispatch
  );

  if (!isLoaded) return null;

  return (
    <AppConfigContext.Provider value={{ config, setConfig, configDispatch }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error("useAppContext must be used within a AppContextProvider");
  }
  return context;
};
export default AppConfigContext;
